export const HEADER_CELL_STYLE = { backgroundColor: 'white' };

export const SCOPE_LABELS = {
  company: 'Company',
  workflow: 'Form',
  action: 'Workflow step',
  non_form: 'Non-form',
};

export const REASON_LABELS = {
  complaint_rate: 'Complaint Rate',
  bounce_rate: 'Bounce Rate',
  ses_tenant_paused: 'SES Paused Sending',
};

export const formatPercent = (rate) => {
  if (rate === null || rate === undefined) return null;
  const value = Number(rate);
  if (Number.isNaN(value)) return null;
  return `${(value * 100).toFixed(2)}%`;
};

export const blockTitle = (block) => {
  if (block.scope === 'company') return 'All company email';
  if (block.scope === 'non_form') return block.emailType || 'Non-form email';
  if (block.templateName) return block.templateName;
  return 'Form';
};